// extracted by mini-css-extract-plugin
module.exports = {"btn":"styles_btn__1Qk5o","backBtn":"styles_backBtn__1nqkF"};